import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const donationDoneeFields: FieldInterface[] = [
  {
    key: 'part',
    originKey: 'part',
    type: FIELD_TYPES.number,
  },
  {
    key: 'personId',
    originKey: 'person_id',
    type: FIELD_TYPES.string,
  },
  {
    key: 'amount',
    originKey: 'amount',
    type: FIELD_TYPES.number,
  },
]

const donationDoneeRelations: RelationInterface[] = [
  {
    key: '_donation',
    originKey: 'donation',
    objectType: OBJECT_TYPES.donation,
  },
  {
    key: '_donee',
    originKey: 'donee',
    objectType: OBJECT_TYPES.person,
  },
]

export { donationDoneeFields, donationDoneeRelations }
